"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var PromptableInboxConnectOptInFlowContainer = _interopRequireWildcard(require("InboxConnectUtils/components/PromptableInboxConnectOptInFlowContainer"));

var _ConnectInbox2 = _interopRequireDefault(require("./lib/ConnectInbox"));

var _Links = require("./utils/Links");

var _serviceTypes = _interopRequireDefault(require("./constants/serviceTypes"));

var _gmailLegalPrompt = PromptableInboxConnectOptInFlowContainer.gmail;

var ConnectGmailInbox = /*#__PURE__*/function (_ConnectInbox) {
  (0, _inherits2.default)(ConnectGmailInbox, _ConnectInbox);

  function ConnectGmailInbox() {
    (0, _classCallCheck2.default)(this, ConnectGmailInbox);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ConnectGmailInbox).call(this, _Links.GMAIL_OAUTHOR_BASE, _serviceTypes.default.gmail, _gmailLegalPrompt));
  }

  return ConnectGmailInbox;
}(_ConnectInbox2.default);

var _default = new ConnectGmailInbox();

exports.default = _default;
module.exports = exports.default;